'use client'

import { useTranslations } from 'next-intl'
import React from 'react'

import { IEmployee, IEmployeeReduced } from '@/_types'

import ASectionAssignedEmployeesList from './components/a-section-assigned-employees-list'

interface IZSectionAssignedEmployeesProps {
	title?: string
	initialEmployeesCount?: number
	employees: IEmployeeReduced[] | IEmployee[]
	orderUrl?: string
}

const ZSectionAssignedEmployees = ({
	employees,
	title,
	initialEmployeesCount = 3,
	orderUrl
}: IZSectionAssignedEmployeesProps) => {
	const t = useTranslations('components.sections.employees')

	return (
		<section
			id='medante-odbornici'
			className='box_detail-amb-employees--new bg_move3 pdt-30md pdt-60lg pdt-130 pdb-20lg pdb-120 mt-10 md:mt-22'
		>
			<div className='wrapper_full px-[24px]'>
				<div className='wrapper_amb'>
					<div className='section_head v2 mgl-0lg mgl-120'>
						<div className='anim_delay anim_drop1 observe'>
							<h2 className='title_h2 mgr-10lg mgr-40'>{title || t('title')}</h2>
						</div>
					</div>

					<div className='hide_mdm'>
						<ASectionAssignedEmployeesList
							employees={employees}
							initialEmployeesCount={initialEmployeesCount}
							orderUrl={orderUrl}
						/>
					</div>

					<div className='show_mdm'>
						<ASectionAssignedEmployeesList
							employees={employees}
							initialEmployeesCount={initialEmployeesCount + 1}
							orderUrl={orderUrl}
						/>
					</div>
				</div>
			</div>
		</section>
	)
}

export default ZSectionAssignedEmployees
